import { render, staticRenderFns } from "./Liked.vue?vue&type=template&id=2f5e8496&"
import script from "./Liked.vue?vue&type=script&lang=js&"
export * from "./Liked.vue?vue&type=script&lang=js&"
import style0 from "./Liked.vue?vue&type=style&index=0&id=2f5e8496&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports